import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SageErrorFixStore, SalesItemRow } from './sage-error-fix.store';

const PAGE = 50;

/** A sales group per item: searchable, 50 at a time, each choice saved at once. */
@Component({
  selector: 'app-sales-group-items',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sales-group-items.component.html',
  styleUrls: ['../onboarding-wizard/sage-wizard.shared.css', '../sage-mockup.shared.css', './fix-section.shared.css'],
})
export class SalesGroupItemsComponent {
  @Input({ required: true }) store!: SageErrorFixStore;
  @Input() idPrefix = '';

  query = '';
  limit = PAGE;

  readonly trackRow = (_: number, r: SalesItemRow) => r.recordId;

  get filtered(): SalesItemRow[] {
    const q = this.query.trim().toLowerCase();
    return q ? this.store.salesItems.filter((r) => r.name.toLowerCase().includes(q) || r.code.toLowerCase().includes(q)) : this.store.salesItems;
  }

  get shown(): SalesItemRow[] {
    return this.filtered.slice(0, this.limit);
  }

  get more(): number {
    return Math.min(PAGE, this.filtered.length - this.shown.length);
  }

  search(value: string): void {
    this.query = value;
    this.limit = PAGE;
  }

  choose(row: SalesItemRow, value: string): void {
    if (value === 'default') {
      this.store.setItemGroup(row, null);
      return;
    }
    const id = Number(value);
    if (id) this.store.setItemGroup(row, id);
  }
}
